import { render, staticRenderFns } from "./smartcontract.vue?vue&type=template&id=2abf90f8&scoped=true"
import script from "./smartcontract.vue?vue&type=script&lang=js"
export * from "./smartcontract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf90f8",
  null
  
)

export default component.exports